import { DETAIL, THUMB, TILE, BADGE_DETAIL, BADGE_TILE, ORIGINAL } from 'constants/api-images-types';
import { curryRight } from 'lodash';
import imageDpiResolution from 'util/dom/image-dpi-resolution';
import staticPath from 'util/misc/static-assets-path';

const product = {
    [TILE]: 'amigos_web_tile',
    [THUMB]: 'amigos_web_thumb',
    [DETAIL]: 'amigos_web_detail',
    [BADGE_DETAIL]: 'amigos_web_badge_detail',
    [BADGE_TILE]: 'amigos_web_badge_tile',
    [ORIGINAL]: 'original',
};

const brand = 'amigos_brands';

const postfix = {
    default: '_1x',
    retina: '_2x',
};

const SIZE_TMP_VAR = '{size}';
const STACK_CHUNK = '{stack}';

/**
 * Generate the proper image source attributes object starting by the image path url received by api
 * @param {string} path - path containing the {stack} that should be replaced
 * @param {string} type - string that must replace the {stack} token
 * @returns {object} - valid image attributes object that can be parsed by image-attributes.js
 */
function pathsByType(path, type) {
    const base = path && path.replace(STACK_CHUNK, `${ type }${ SIZE_TMP_VAR }`);
    const fallback = staticPath('img/icons/missing-product-image.svg');

    return {
        src: {
            '@1': base ? base.replace(SIZE_TMP_VAR, postfix.default) : fallback,
            '@2': base ? base.replace(SIZE_TMP_VAR, postfix.retina) : fallback,
        },
    };
}

export const brandImage = curryRight(pathsByType)(brand);

// Get the original image from the url received
export const originalImage = path => path.replace(STACK_CHUNK, ORIGINAL);

export function productImage(path, type) {
    if (!product[type]) {
        throw new Error(`The product type "${ type }" has no stack images`);
    }

    return pathsByType(path, product[type]);
}

/**
 * Take any of the image sources produced above and returns a unique source attribute based on the screen DPI
 * @param {object} data.src - the return of any of the functions above
 * @returns {string} a clean image path
 */
export function imageByDpi({ src }) {
    return src[`@${ Math.min(imageDpiResolution(), 2) }`];
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/react/stack-images-path.js